module.exports = __webpack_public_path__ + "static/img/thumb_Tax_Invoice.c5fbb09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/receipts/thumb/thumb_Tax_Invoice.png
// module id = BBgf
// module chunks = 31